<ul class="list">
  <slot />
</ul>

<style lang="scss">
  @use '../styles/spacing';

  .list {
    list-style: square;
    margin-top: spacing.$xs;
    margin-left: spacing.$s;
  }
</style>
